import { api } from './api';

const toList = (value) => (Array.isArray(value) ? value : value?.data || []);

export const employeeService = {
  // --- Reports ---
  getReports: ({ page = 1, limit = 10 } = {}) =>
    api.get('/employee/uniform-reports', { params: { page, limit } }),

  getCurrentReport: () => api.get('/employee/uniform-reports/current'),

  getReportById: (uniformReportId) =>
    api.get(`/employee/uniform-reports/${uniformReportId}`),

  createReport: (payload = {}) => api.post('/employee/uniform-reports', payload),

  updateReport: (uniformReportId, payload = {}) =>
    api.put(`/employee/uniform-reports/${uniformReportId}`, payload),

  submitReport: (uniformReportId) =>
    api.put(`/employee/uniform-reports/${uniformReportId}`, { report_status: 'submitted' }),

  // --- Report Details ---
  getReportDetails: (uniformReportId, { page = 1, limit = 10 } = {}) =>
    api.get(`/employee/uniform-reports/${uniformReportId}/details`, { params: { page, limit } }),

  addReportDetail: (uniformReportId, { uniform_id, qty, url_photo, notes }) =>
    api.post(`/employee/uniform-reports/${uniformReportId}/details`, { uniform_id, qty, url_photo, notes }),

  updateReportDetail: (detailId, { qty, url_photo, notes }) =>
    api.put(`/employee/uniform-report-details/${detailId}`, { qty, url_photo, notes }),

  deleteReportDetail: (detailId) =>
    api.delete(`/employee/uniform-report-details/${detailId}`),

  // --- Master data ---
  getUniforms: async ({ page, limit } = {}) => {
    const res = await api.get('/employee/uniforms', { params: { page, limit } });
    return { ...res, data: toList(res.data) };
  },

  getUniformCategories: ({ page = 1, limit = 10 } = {}) =>
    api.get('/employee/uniform-categories', { params: { page, limit } }),

  // --- Profile ---
  getEmployeeProfile: () => api.get('/employee/profile'),

  updateProfile: ({ name, phone }) => api.put('/employee/profile', { name, phone }),

  // --- History ---
  getReportsHistory: ({ page = 1, limit = 10 } = {}) =>
    api.get('/employee/uniform-reports/history', { params: { page, limit } }),
};

